import { useQuery } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { User } from '@/models/User';

const useUser = (enabled: boolean = true) => {
  const queryKey = ['user'];

  const queryFn = async () => {
    return getUser();
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 15,
    retry: false,
  });
};

export default useUser;

async function getUser(): Promise<User | null> {
  try {
    const response = await BackendClient.get<BackendSuccessResponse<User>>('/api/auth/user');

    return response.data.data;
  } catch (e) {
    console.error(e);
    return null;
  }
}
